var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "kobraSearchbar" } }, [
    _c("div", { staticClass: "flex text-center margin-bottom-20" }, [
      _c(
        "div",
        {
          staticClass: "width100 padding-horizontal-30 padding-horizontal-s-0",
        },
        [
          _c(
            "button",
            {
              staticClass: "fa formSearchbar__submit",
              attrs: {
                id: "kobraSearchSubmit",
                type: "button",
                "data-content": "",
              },
              on: { click: _vm.updateKobraSearch },
            },
            [_c("i", { staticClass: "fa-search fa" })]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            staticClass: "search-autocomplete",
            attrs: {
              id: "kobraQuery",
              type: "text",
              name: "q",
              required: "required",
              maxlength: "1024",
              autofocus: "autofocus",
              autocomplete: "off",
            },
            domProps: { value: _vm.searchQuery },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.updateKobraSearch.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchQuery = $event.target.value
              },
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }